module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<div id="acWrap">\r\n        <div id="acContent" class="cf clearfix">\r\n            <div class="content-img">\r\n                <img src="' +
((__t = ( o.licenseLink )) == null ? '' : __t) +
'" /> \r\n            </div>\r\n        </div>\r\n</div>\r\n';

}
return __p
}


//////////////////
// WEBPACK FOOTER
// ./src/js/hotelDetail/templates/hotelLicensesTmpl.ejs
// module id = 338
// module chunks = 6